module.exports = __webpack_public_path__ + "static/media/T5.096261d5.jpg";